import { Button, Col, Divider, Input, Modal, Row, Select, TimePicker } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import AppContext from "../../../context/app/context";
import InvestorContext from "../../../context/investor/context";
import InvestorContextProvider from "../../../context/investor/provider";
import { ILightResonse } from "../../../models/general-models/general";

import {
  getInvestorStatus,
  getInvestorType,
} from "../../../models/investor/enum";
import { IUpdateInvestor } from "../../../models/investor/request";
import { MediumFor } from "../../../models/medium/enum";
import { IStore } from "../../../models/store/response";
import { getUserStatus } from "../../../models/user/enum";
import EndPoints from "../../../services/end-points";
import { languages } from "../../../utils/helpers/constants";
import { getTranslations } from "../../../utils/helpers/translations";
import Controller from "../../form-components/controller";
import FieldBuilder from "../../form-components/field-builder";
import ImageUploader from "../../form-components/image-uploader";
import OldImage from "../../form-components/old-image";
import Spin from "../../general/antd/spin";
import FormItem from "../../general/form-item";
import DataTable from "../investor-work-times-table";
import AddBtnTable from "../../general/table-components/actions/add-table-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import { IWorkTime, IWorkTimeOfDay } from "../../../models/investor/response";
import { convertToDateTime } from "../../../utils/helpers/format-time";
import TimePickerWithDisabledRanges from "../time-picker";
import styles from "./style.module.scss";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { FormProvider, useForm } from "react-hook-form";
import { execute } from "../../../utils/helpers/execute";
import { getWorkDayFromZero, weekDaysFromZero } from "../../../context/investor/enum";
import { createActiveStoreFilter } from "../../../utils/helpers/store-filters";

dayjs.extend(utc);

const Form = () => {
  const { t } = useTranslation();
  const { details, actions, loading } = useContext(InvestorContext);
  const { id } = useParams();
  const { direction } = useContext(AppContext);
  const investorStatus = [1, 2];
  const investorTypes = [1, 2];

  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const navigate = useNavigate();

  const [cities, setCities] = useState<ILightResonse[]>([]);
  const [citiesLoading, setCitiesLoading] = useState(true);

  const [stores, setStores] = useState<IStore[]>([]);
  const [storesLoadin, setStoresLoadin] = useState<boolean>(false);
{/* ---------------- work times ------------------ */}
  const [modalVisible, setModalVisible] = useState(false);

  const [startTime, setStartTime] = useState(null);

  const [endTime, setEndTime] = useState(null);
 
  const [workTimesGroupedByDay, setWorkTimesGroupedByDay] = useState<IWorkTimeOfDay[]>([]);

  const [selectWorkTimesOfDay, setSelectWorkTimesOfDay] = useState<IWorkTimeOfDay>();

  const [selectStartTimesOfDay, setSelectStartTimesOfDay] = useState<IWorkTimeOfDay>();

  const [selectEndTimesOfDay, setSelectEndTimesOfDay] = useState<IWorkTimeOfDay>();

  const handleAddWorkTime = () => {
    if (!selectStartTimesOfDay || !startTime || !endTime) {
      console.error("Invalid input: Ensure a day is selected and times are provided.");
      return;
    }
    const updatedWorkTimes = [...workTimesGroupedByDay];
  
    const dayIndex = updatedWorkTimes.findIndex(
      (day) => day.dayId === selectStartTimesOfDay.dayId
    );
    
    const getDateByDayIndex = (dayIndex) => {
      const day = weekDaysFromZero.find((day) => day.value === dayIndex);
      return day ? day.date : null; 
    };

    const dateForDayIndex = getDateByDayIndex(dayIndex);
    const dateOnly = dayjs(dateForDayIndex).format('YYYY-MM-DD');
    
    if (dayIndex !== -1) {
      updatedWorkTimes[dayIndex] = {
        ...updatedWorkTimes[dayIndex],
        workTimes: [
          ...updatedWorkTimes[dayIndex].workTimes,
          { startTime: `${dateOnly}T${startTime}:00Z`, endTime: `${dateOnly}T${endTime}:00Z` },
        ],
      };
    }
    console.log(updatedWorkTimes)
    setWorkTimesGroupedByDay(updatedWorkTimes);
    setModalVisible(false);
  };  

  const handleDeleteWorkTime = (dayId:number, workTime:IWorkTime) => {
    
    const updatedWorkTimesGroupedByDay = [...workTimesGroupedByDay];
  
    const dayIndex = updatedWorkTimesGroupedByDay.findIndex(
      (day) => day.dayId === dayId
    );
  
    if (dayIndex !== -1) {
      updatedWorkTimesGroupedByDay[dayIndex] = {
        dayId,
        workTimes: updatedWorkTimesGroupedByDay[dayIndex].workTimes.filter((e)=>{
          return (e.startTime !== workTime.startTime && e.startTime !== workTime.endTime)
        }),
      };
    }
    setWorkTimesGroupedByDay(updatedWorkTimesGroupedByDay);
  };  

  const showModal = (workTimeOfDay?:IWorkTimeOfDay) => {
    setModalVisible(true);
    setSelectWorkTimesOfDay(workTimeOfDay);
    setSelectStartTimesOfDay(workTimeOfDay);
    setSelectEndTimesOfDay(workTimeOfDay);
  };

  const handleCancel = () => {
    setModalVisible(false);
    setStartTime(null);
    setEndTime(null);
  };

  useEffect(() => {
    if (startTime) {
      const startTimeMoment = dayjs(startTime, "HH:mm");
  
      const filteredEndTimes = selectWorkTimesOfDay.workTimes.filter(workTime => {
        const endTimeMoment = dayjs(workTime.endTime, "HH:mm");

        return endTimeMoment.isAfter(startTimeMoment);
      });
      const endTimes = [{
        startTime: convertToDateTime("00:00",selectWorkTimesOfDay.dayId) ,
        endTime: convertToDateTime(startTime,selectWorkTimesOfDay.dayId)
      } as IWorkTime,...filteredEndTimes]
      setSelectEndTimesOfDay({
        dayId: selectWorkTimesOfDay.dayId,
        workTimes: endTimes,
      } as IWorkTimeOfDay);
    } else {
      setSelectEndTimesOfDay(selectWorkTimesOfDay);
    }
  }, [startTime]);
  
  useEffect(() => {
    if (endTime) {
      const endTimeMoment = dayjs(endTime, "HH:mm");
  
      const filteredStartTimes = selectWorkTimesOfDay.workTimes.filter(workTime => {
        const startTimeMoment = dayjs(workTime.startTime, "HH:mm");

        return startTimeMoment.isBefore(endTimeMoment);
      });
      const startTimes = [...filteredStartTimes,{
        startTime: convertToDateTime(endTime,selectWorkTimesOfDay.dayId) ,
        endTime: convertToDateTime("23:59",selectWorkTimesOfDay.dayId)
      } as IWorkTime]

      setSelectStartTimesOfDay({
        dayId: selectWorkTimesOfDay.dayId,
        workTimes: startTimes,
      } as IWorkTimeOfDay);
    } else {
      setSelectStartTimesOfDay(selectWorkTimesOfDay);
    }
  }, [endTime]);
  {/* ---------------- work times ------------------ */}
    const methods = useForm<any>({
      defaultValues: {
        firstName: details?.user?.firstName,
        lastName: details?.user?.lastName,
        mobile: details?.user?.cleanMobile,
        email: details?.user?.email,
        address: details?.address,
        phone: details?.user?.phone,
        type: details?.type,
        statusInvestor: details?.statusInvestor,  
        status: details?.user?.status,
        birthDate: details?.birthDate,
        nationalIdentityNumber: details?.nationalIdentityNumber,
        cityId: details?.city?.id,
        storeId: details?.store?.id,
        imageId: details?.user?.image?.id ?? undefined,
        note: getTranslations(details?.user?.translations?.note) ?? null,
        workTimes: details?.workTimes
      } as IUpdateInvestor,
    });

    
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = methods;

  useEffect(() => {
    const getCities = async () => {
      try {
        const { data } = await EndPoints.city.getAllCities({
          light: true,
          perPage: -1,
        });
        setCities(data.data);
        setCitiesLoading(false);
      } catch (error) {
      } finally {
        setCitiesLoading(false);
      }
    };
    getCities();
  }, [direction]);

  useEffect(() => {
    const getStores = async () => {
      try {
        const { data } = await EndPoints.store.getAllStores({
          light: true,
          perPage: -1,
          filters: [createActiveStoreFilter()],
        });
        setStores(data.data);
        setStoresLoadin(false);
      } catch (error) {
      } finally {
        setCitiesLoading(false);
      }
    };
    getStores();
  }, [direction]);

  useEffect(() => {
    const getDetails = async () => {
      if (id) {
        await actions.getDetails(Number(id));
      } else {
        const emptyWorkDays = weekDaysFromZero.map((day) => ({
          dayId: day.value,
          workTimes: [],
        } as IWorkTimeOfDay));

        setWorkTimesGroupedByDay(emptyWorkDays);
      }
    };
    getDetails();
  }, [id]);

    useEffect(() => {
      if (details?.workTimes) {
        const weekDays = details.workTimes.map((workTime) => {
          const dateOnly = dayjs(workTime.startTime).format("YYYY-MM-DD");
          const day = weekDaysFromZero.find((day) => day.date === dateOnly);
          return day ? day.value : -1;
        });
    
        const workTimesOfDay = weekDays.map((day) => {
          const reservedTime = details.workTimes.filter((workTime) => {
            const dateOnly = dayjs(workTime.startTime).format("YYYY-MM-DD");
            const matchedDay = weekDaysFromZero.find((d) => d.date === dateOnly);
            return matchedDay && matchedDay.value === day;
          });
    
          const reservedTimeFormated = reservedTime.map((item) => {
            const dateOnly = dayjs(item.startTime).format("YYYY-MM-DD");
            const startTime = dayjs(item.startTime).toISOString().split("T")[1];
            const endTime = dayjs(item.endTime).toISOString().split("T")[1];
            return {
              startTime: `${dateOnly}T${startTime}`,
              endTime: `${dateOnly}T${endTime}`,
            } as IWorkTime;
          });
    
          return {
            dayId: day,
            workTimes: reservedTimeFormated,
          } as IWorkTimeOfDay;
        });
    
        const filteredDays = weekDaysFromZero.filter(
          (day) => !weekDays.includes(day.value)
        );
    
        const workDaysEmpty = filteredDays.map(
          (day) =>
            ({
              dayId: day.value,
              workTimes: [],
            } as IWorkTimeOfDay)
        );
    
        const mergedWorkDays = [...workTimesOfDay, ...workDaysEmpty].reduce(
          (acc, current) => {
            const existingDay = acc.find((item) => item.dayId === current.dayId);
            if (!existingDay) {
              acc.push(current); 
            }
            return acc;
          },
          [] as IWorkTimeOfDay[]
        );
    
        mergedWorkDays.sort((a, b) => a.dayId - b.dayId);
        setWorkTimesGroupedByDay(mergedWorkDays);
      }
      reset({
        firstName: details?.user?.firstName,
        lastName: details?.user?.lastName,
        mobile: details?.user?.cleanMobile,
        email: details?.user?.email,
        address: details?.address,
        phone: details?.user?.phone,
        type: details?.type,
        statusInvestor: details?.statusInvestor,  
        status: details?.user?.status,
        birthDate: details?.birthDate,
        nationalIdentityNumber: details?.nationalIdentityNumber,
        cityId: details?.city?.id,
        storeId: details?.store?.id,
        imageId: details?.user?.image?.id ?? undefined,
        note: getTranslations(details?.user?.translations?.note) ?? null,
        workTimes: workTimesGroupedByDay.flatMap((day) =>day.workTimes)
      } as IUpdateInvestor);
    }, [details]);


      const onSubmit = async (data: any) => {
        await execute({
          callback: async () => {
            setLoadingSubmit(true);
            details
              ? await EndPoints.investor.updateInvestor(details?.id, 
                {
                  ...data,
                  workTimes: workTimesGroupedByDay.flatMap((day) =>day.workTimes), 
                }
              )
              : await EndPoints.investor.createInvestor(
                {
                  ...data,
                  workTimes: workTimesGroupedByDay.flatMap((day) =>day.workTimes), 
                }
              );
            navigate(-1);
          },
          fallback: (error) => {},
          finallyCallback: () => {
            setLoadingSubmit(false);
          },
          throwException: false,
        });
      };
      
  return (
    <FormProvider {...methods}>
      <form className={styles.container} style={{padding: "20px"}} onSubmit={handleSubmit(onSubmit)}>
        <div>
          <span className={styles.title}>
            {details ? t("update_investor") : t("add_investor")}
          </span>
          <Divider className={styles.divider} />
          {loading.includes("details") ? (
            <div style={{ height: "60vh" }}>
              <Spin />
            </div>
          ) : (
            <>
            <Row gutter={[16, 8]}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="firstName"
                label={t("first_name")}
                input={{ type: "text" }}
                rules={{ required: true }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="lastName"
                label={t("last_name")}
                input={{ type: "text" }}
                rules={{ required: true }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="mobile"
                label={t("mobile")}
                input={{ type: "text" }}
                rules={{ required: true }}
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="email"
                label={t("email")}
                input={{ type: "email" }}
                rules={{ required: false }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="address"
                label={t("address")}
                input={{ type: "text" }}
                rules={{ required: false }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="phone"
                label={t("phone")}
                input={{ type: "text" }}
                rules={{ required: false }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="status"
                label={`${t("status")}`}
                width="large"
                rules={{ required: true }}
                input={{
                  type: "select",
                  loading: false,
                  options: investorStatus?.map((state, index) => {
                    return {
                      key: index,
                      label: t(getUserStatus(state)),
                      value: state,
                    };
                  }),
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="type"
                label={`${t("type")}`}
                width="large"
                rules={{ required: true }}
                input={{
                  type: "select",
                  loading: false,
                  options: investorTypes?.map((state, index) => {
                    return {
                      key: index,
                      label: t(getInvestorType(state)),
                      value: state,
                    };
                  }),
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="statusInvestor"
                label={`${t("current_status")}`}
                width="large"
                rules={{ required: true }}
                input={{
                  type: "select",
                  loading: false,
                  options: investorTypes?.map((state, index) => {
                    return {
                      key: index,
                      label: t(getInvestorStatus(state)),
                      value: state,
                    };
                  }),
                }}
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="birthDate"
                label={`${t("birth_date")}`}
                rules={{ required: false }}
                input={{ type: "date-picker", format: "YYYY-MM-DD" }}
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="nationalIdentityNumber"
                label={t("national_identity_number")}
                input={{ type: "text" }}
                rules={{ required: false, minLength: 11, maxLength: 11 }}
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="cityId"
                label={`${t("city")}`}
                width="large"
                rules={{ required: true }}
                input={{
                  type: "select",
                  loading: citiesLoading,
                  allowSearch: false,
                  options: cities?.map((city, index) => {
                    return {
                      key: index,
                      label: city.name,
                      value: city.id,
                    };
                  }),
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <FieldBuilder
                name="storeId"
                label={`${t("store")}`}
                width="large"
                rules={{ required: true }}
                input={{
                  type: "select",
                  loading: citiesLoading,
                  allowSearch: true,
                  options: stores?.map((store, index) => {
                    return {
                      key: index,
                      label: store.name,
                      value: store.id,
                    };
                  }),
                }}
              />
            </Col>
            <Col span={12}></Col>
              {languages?.map((lang, index) => {
                return (
                    <Col xs={24} sm={24} md={12}>
                      <FieldBuilder
                          key={index}
                          name={`note[${lang?.code}]`}
                          label={`${t("note")} (${lang?.name})`}
                          input={{ type: "text-area" }}
                          rules={{ required: false }}
                      />
                    </Col>
                );
              })}
              <Col span={24}>
                <FormItem label={t("image")}>
                  <Controller
                      name="imageId"
                      rules={{
                        required: {
                          value: false,
                          message: `${t("field_is_required_message")}`,
                        },
                      }}
                      render={({ field: { ref, ...field } }) => {
                        return (
                            <ImageUploader
                                {...field}
                                type="DRAGGER"
                                onChange={(response) => {
                                  // setfileId(response);
                                  field.onChange(response?.id);
                                }}
                                imageFor={MediumFor.UserProfile}
                            />
                        );
                      }}
                  />
                </FormItem>
              </Col>
              {details?.user?.image && (
                  <OldImage src={details?.user?.image?.url} />
              )}
            {/* ---------------- Start work times ------------------ */}
            <Divider className={styles.divider} >{t("work_times")}</Divider>
            <Modal
              open={modalVisible}
              onCancel={handleCancel}
              afterClose={handleCancel}
              destroyOnClose
              onOk={() => {
              handleAddWorkTime();
              setModalVisible(false)
              }}
              title={t("add_work_time")}
            >
             <div style={{ display: "flex", gap: "16px", margin: "20px 0" }}>
            <TimePickerWithDisabledRanges
                workTimeOfDay={selectStartTimesOfDay}
                onChange={(value) => {
                  setStartTime(value?.format("HH:mm"))
                }}
              />
            <TimePickerWithDisabledRanges
              workTimeOfDay={selectEndTimesOfDay}
              onChange={(value) => setEndTime(value?.format("HH:mm"))}
            />
            </div>
            </Modal>
            <Col span={24} style={{ marginBottom: 10, alignItems: "center" }}>
              <DataTable
                columns={[
                  {
                    title: t("Work_days"),
                    dataIndex: "dayId",
                    key: "dayId",
                    render: (dayId: number) => t(getWorkDayFromZero(dayId)),
                  },
                  {
                    title: t("actions"),
                    render: (text, record) => {
                      return (
                        <AddBtnTable
                          size="small"
                          onClick={() => {
                            showModal(record);
                          }}
                        />
                      );
                    },
                    align: "center",
                    width: "15%",
                  },
                ]}
                dataSource={workTimesGroupedByDay}
                rowKey={(record) => record.dayId.toString()}
                expandedRowRender={(recordOfDays) =>
                recordOfDays.workTimes.length > 0 ? (
                  <DataTable
                    columns={[
                      {
                        title: t("start_time"),
                        key: "startTime",
                        render: (text, recordOfTimes) => {
                          const timeOnly = dayjs.utc(recordOfTimes.startTime).format('HH:mm');
                          return <div>{timeOnly}</div>;
                        },
                        align: "center",
                      },
                      {
                        title: t("end_time"),
                        key: "endTime",
                        render: (text, recordOfTimes) => {
                          const timeOnly = dayjs.utc(recordOfTimes.endTime).format('HH:mm');
                          return <div>{timeOnly}</div>;
                        },
                        align: "center",
                      },
                      {
                        title: t("actions"),
                        render: (text, record) => {
                          return (
                            <DeleteBtn
                            size="small"
                              onConfirm={async () => {
                                handleDeleteWorkTime(recordOfDays.dayId, record);
                              }}
                              loading={loading.includes("delete")}
                            />
                          );
                        },
                        align: "center",
                        width: "15%",
                      },
                    ]}
                    dataSource={recordOfDays.workTimes}
                    rowKey={recordOfDays.dayId.toString()}
                  />
                  ) : (
                    <>
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>{t("No_work_times_available_Click_to_add_new_work_time")}</div>
                    </>
                  )
                }
              />
            </Col>
            {/* ----------------- End work times ------------------- */}

            </Row>
            </>
          )}
        </div>  
        <div>
          <div className={styles.formFooter}>
            <Button
              onClick={() => {
                navigate(-1);
              }}
            >
              {t("cancel")}
            </Button>
            <Button loading={loadingSubmit} htmlType="submit" type="primary">
              {t("save")}
            </Button>
          </div>
          </div>
      </form>
    </FormProvider>
    );
};

const InvestorForm = () => {
  return (
    <InvestorContextProvider>
      <Form />
    </InvestorContextProvider>
  );
};
export default InvestorForm;

